<template>
  <div id="app">
    <el-container v-if="isLoadingFunc">
      <navigation />
      <el-main v-bind:class="isSubmenuFunc ?  '' : 'dashboard'" >
        <header-strip></header-strip>
        <router-view></router-view>
      </el-main> 
    </el-container>
    <div v-if="dashLoader" class="loading"></div> 
  </div>
</template>
<script>
import SideBar from '../components/SideBar.vue'
import HeaderStrip from '../components/common/HeaderStrip.vue'
import Submenu from '../components/Submenu.vue'
import Navigation from '../components/common/Navigation.vue';
export default {
  mounted() {
    this.isLoading = true;
  },
  components:{
    'side-bar':SideBar,
    'header-strip':HeaderStrip,
    'sub-menu':Submenu,
    'navigation': Navigation
  },
  data () {
    return {
      isLoading:false,
      open: false
    }
  },
  computed:{
    isLoadingFunc:function(){
      let token = this.$store.getters['auth/getToken'];
      if(token) return this.isLoading;
    },
    isSubmenuFunc:function(){
      return this.$store.getters['uicomponents/isSubmenu'];
    },
    dashLoader () {
      return this.$store.getters['dashboard/getDashLoader']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/DesktopLayout.vue